module.exports = __webpack_public_path__ + "img/vertical_4_7_8004.bfee7c67.png";